import dynamic from 'next/dynamic'
import { TLoggedInSideBarUSL2Props } from './types'
import { useUserRQInfo } from '@/components/Common/user-provider/user-provider'

const LoggedInSidebar = dynamic(() => import('./logged-in-sidebar'), {
  ssr: false,
})

export function LoggedInSidebarUSL2Lazy(props: TLoggedInSideBarUSL2Props) {
  const { isAuthenticated } = useUserRQInfo()

  if (!isAuthenticated) {
    return null
  }
  return <LoggedInSidebar {...props} />
}
